import { render } from "./DashboardRealizedBudget.vue?vue&type=template&id=195125c6&scoped=true&ts=true"
import script from "./DashboardRealizedBudget.vue?vue&type=script&lang=ts"
export * from "./DashboardRealizedBudget.vue?vue&type=script&lang=ts"

import "./DashboardRealizedBudget.vue?vue&type=style&index=0&id=195125c6&lang=scss&scoped=true"

import exportComponent from "/home/node/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-195125c6"]])

export default __exports__